import { useEffect, useState } from 'react';
import { getGoals } from '../notifications.service';
import { getTeamGoalsDashboard } from 'common/services/metrics.service';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';

export const useNotifications = ({ selectedTeamId }) => {
  const [notifications, setNotifications] = useState([]);
  const [teamDashboard, setTeamDashboard] = useState({});
  const notificationData = [];
  const { getSettingOrDefinitionValue, getSettingDefinition } =
    useSettingsService();
  const NOTIFICATIONS_BUILDER = getGoals();

  Object.entries(NOTIFICATIONS_BUILDER).forEach(([key, value]) => {
    const notificationValue =
      getSettingOrDefinitionValue({
        name: key,
        definitionLevel: 'team',
        teamId: selectedTeamId
      }) || {};

    const notificationDefinition =
      getSettingDefinition({
        name: key,
        definitionLevel: 'team'
      }) || {};

    notificationData.push({
      id: notificationDefinition.id,
      notificationKey: notificationDefinition.name,
      schema: notificationDefinition.schema,
      defaultValue: notificationDefinition.defaultValue,
      values: notificationValue,
      icon: value.icon,
      articleId: value.articleId,
      isNew: value.isNew,
      isHeadsUp: value.isHeadsUp,
      widgetId: value.widgetId
    });
  });

  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.SETTINGS,
      page_tab: TRACKING.PAGE_TABS.NOTIFICATIONS
    });
    setNotifications(notificationData);

    const getTeamDashboard = async () => {
      const { teamDashboardId, widgets = [] } = await getTeamGoalsDashboard(
        selectedTeamId
      );
      setTeamDashboard({
        teamDashboardId,
        teamDashboardWidgets: widgets.map(({ id }) => id)
      });
    };
    getTeamDashboard();
  }, [selectedTeamId]);

  return {
    notifications,
    setNotifications,
    NOTIFICATIONS_BUILDER,
    teamDashboard,
    setTeamDashboard
  };
};
